import { Constants } from '@/cfg/constants';

const REGION_LABELS = Object.freeze({
  uk: 'UK',
  global: 'US',
});

function isTruthy(value) {
  return value === true || value === 'true' || value === 1 || value === '1';
}

export function getPendo(user) {
  if (typeof window === 'undefined' || !window.pendo) {
    return null;
  }

  const disablePendo = Constants.REGION === 'uk' && isTruthy(user?.attributes?.disable_pendo);
  if (disablePendo) {
    if (typeof window.pendo.teardown === 'function') {
      window.pendo.teardown();
    }
    return null;
  }

  return window.pendo;
}

export function getPendoRegion() {
  return REGION_LABELS[Constants.REGION] || Constants.REGION;
}

// The deployed environment is not exposed as its own variable, so it is derived
// from the API host (api.qa.forum..., api.stage.forum..., api.forum...).
export function getPendoServer(apiUrl = Constants.API_URL) {
  let host = '';
  try {
    host = new URL(apiUrl).hostname.toLowerCase();
  } catch (e) {
    host = String(apiUrl || '').toLowerCase();
  }

  const labels = host.split('.');
  if (labels.includes('qa')) {
    return 'QA';
  }
  if (labels.includes('stage') || labels.includes('staging')) {
    return 'Stage';
  }
  if (labels.includes('dev') || host.includes('localhost')) {
    return 'Dev';
  }
  return 'Production';
}

export function getPendoVisitorMetadata(user, language) {
  const metadata = {
    forum_language: language,
    region: getPendoRegion(),
    server: getPendoServer(),
  };

  const company = user?.organization?.name;
  if (company) {
    metadata.company = company;
  }

  return metadata;
}
